module.exports = __webpack_public_path__ + "readmeTemplates/OSH_maintenance.cb3c0a1c75b2eb9500280de7d9a0d7e8.md";